import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Row, Col, Table, Button } from 'react-bootstrap';
import { WorkflowTaskLog } from '../../data/WorkflowTaskLog/schemas/WorkflowTaskLog.schema';
import { formatYMDToDMY } from '../../modules/Common';

type Props = {
    isOpen?: boolean;
    onClose?: () => void;
    workflowTaskLog?: WorkflowTaskLog[];
};

const ACTION_STYLES: Record<string, React.CSSProperties> = {
    added: { backgroundColor: '#d4edda', color: '#155724' },
    edit: { backgroundColor: '#d1ecf1', color: '#0c5460' },
    deleted: { backgroundColor: '#f8d7da', color: '#721c24' }
};

function WorkflowTaskLogModal(props: Props) {
    const { isOpen, onClose, workflowTaskLog } = props;

    return (
        <Modal
            className="h-[90%] w-[98%] max-w-[1920px]"
            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalHeader>
                <p className="text-base font-semibold">Workflow Task Change Log</p>
            </ModalHeader>
            <ModalBody>
                <div style={{ overflowX: 'scroll' }} className='mt-2'>
                    <Table className="table-bordered table-hover">
                        <thead>
                            <tr
                                className="table-active thead-light text-nowrap text-center"
                                style={{ width: '100%' }}
                            >
                                <th>Time</th>
                                <th>Subject</th>
                                <th>Action</th>
                                <th>Object</th>
                            </tr>
                        </thead>
                        <tbody>
                            {workflowTaskLog && workflowTaskLog
                                .sort((a, b) => (a.created_on ?? '') < (b.created_on ?? '') ? 1 : -1)
                                .map((item, idx) => {
                                    const actionStyle = ACTION_STYLES[item.action ?? ''] ?? {};

                                    return (
                                        <tr id={"addr" + idx} key={idx} style={actionStyle}>
                                            <td>
                                                {formatYMDToDMY(item.created_on ?? '')}
                                            </td>
                                            <td>
                                                {item.created_by}
                                            </td>
                                            <td>
                                                <b>{item.action}</b>
                                            </td>
                                            <td>
                                                {item.details && item.details.map((detail, idy) => (
                                                    <React.Fragment key={idy}>
                                                        {detail.tab ? (
                                                            <>
                                                            {detail.changeType === 'authority_group' ? (
                                                                <>
                                                                    <Row className="show-grid align-items-center">
                                                                        {item.action === 'added' && (
                                                                            <>
                                                                                <Col md="auto">tab</Col>
                                                                                <Col md="auto"><b>{detail.tab}</b></Col>
                                                                                <Col md="auto">added</Col>
                                                                                <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                                <Col md="auto">at</Col>
                                                                                <Col md="auto"><b>{detail.positionNo}</b></Col>
                                                                            </>
                                                                        )}
                                                                        {item.action === 'edit' && (
                                                                            <>
                                                                                <Col md="auto">tab</Col>
                                                                                <Col md="auto"><b>{detail.tab}</b></Col>
                                                                                <Col md="auto">change</Col>
                                                                                <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                                <Col md="auto">at</Col>
                                                                                <Col md="auto"><b>{detail.positionNo}</b></Col>
                                                                                <Col md="auto">from</Col>
                                                                                <Col md="auto"><b>{detail.oldValue}</b></Col>
                                                                                <Col md="auto">to</Col>
                                                                                <Col md="auto"><b>{detail.newValue}</b></Col>
                                                                            </>
                                                                        )}
                                                                        {item.action === 'deleted' && (
                                                                            <>
                                                                                <Col md="auto">tab</Col>
                                                                                <Col md="auto"><b>{detail.tab}</b></Col>
                                                                                <Col md="auto">delete</Col>
                                                                                <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                                <Col md="auto">at</Col>
                                                                                <Col md="auto"><b>{detail.positionNo}</b></Col>
                                                                            </>
                                                                        )}
                                                                    </Row>
                                                                </>
                                                            ) : (
                                                                <Row className="show-grid align-items-center">
                                                                    {item.action === 'added' && (
                                                                        <>
                                                                            <Col md="auto">tab</Col>
                                                                            <Col md="auto"><b>{detail.tab}</b></Col>
                                                                            <Col md="auto">add</Col>
                                                                            <Col md="auto"><b>{detail.parameterId}</b></Col>
                                                                            {detail.authorityGroupId && (
                                                                                <>
                                                                                    <Col md="auto">at</Col>
                                                                                    <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                                </>
                                                                            )}
                                                                            <Col md="auto">operator</Col>
                                                                            <Col md="auto"><b>{detail.operator}</b></Col>
                                                                            <Col md="auto">value</Col>
                                                                            <Col md="auto"><b>{detail.newValue}</b></Col>
                                                                        </>
                                                                    )}
                                                                    {item.action === 'edit' && detail.changeType === 'value' && (
                                                                        <>
                                                                            <Col md="auto">tab</Col>
                                                                            <Col md="auto"><b>{detail.tab}</b></Col>
                                                                            <Col md="auto">change value</Col>
                                                                            <Col md="auto"><b>{detail.parameterId}</b></Col>
                                                                            {detail.authorityGroupId && (
                                                                                <>
                                                                                    <Col md="auto">at</Col>
                                                                                    <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                                </>
                                                                            )}
                                                                            <Col md="auto">from</Col>
                                                                            <Col md="auto"><b>{detail.oldValue}</b></Col>
                                                                            <Col md="auto">to</Col>
                                                                            <Col md="auto"><b>{detail.newValue}</b></Col>
                                                                        </>
                                                                    )}
                                                                    {item.action === 'edit' && detail.changeType === 'operator' && (
                                                                        <>
                                                                            <Col md="auto">tab</Col>
                                                                            <Col md="auto"><b>{detail.tab}</b></Col>
                                                                            <Col md="auto">change operator</Col>
                                                                            <Col md="auto"><b>{detail.parameterId}</b></Col>
                                                                            {detail.authorityGroupId && (
                                                                                <>
                                                                                    <Col md="auto">at</Col>
                                                                                    <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                                </>
                                                                            )}
                                                                            <Col md="auto">from</Col>
                                                                            <Col md="auto"><b>{detail.oldValue}</b></Col>
                                                                            <Col md="auto">to</Col>
                                                                            <Col md="auto"><b>{detail.newValue}</b></Col>
                                                                        </>
                                                                    )}
                                                                    {item.action === 'deleted' && (
                                                                        <>
                                                                            <Col md="auto">tab</Col>
                                                                            <Col md="auto"><b>{detail.tab}</b></Col>
                                                                            <Col md="auto">delete</Col>
                                                                            <Col md="auto"><b>{detail.parameterId}</b></Col>
                                                                            {detail.authorityGroupId && (
                                                                                <>
                                                                                    <Col md="auto">at</Col>
                                                                                    <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                                </>
                                                                            )}
                                                                            <Col md="auto">operator</Col>
                                                                            <Col md="auto">{detail.operator}</Col>
                                                                            <Col md="auto">value</Col>
                                                                            <Col md="auto">{detail.oldValue}</Col>
                                                                        </>
                                                                    )}
                                                                </Row>
                                                            )}
                                                            </>
                                                        ) : (
                                                            detail.columnName !== 'sid' && (
                                                                <Row className="show-grid">
                                                                    <Col md={2}><b>{detail.id}</b></Col>
                                                                    <Col md={1}>{item.action === 'edit' ? 'change' : (item.action === 'added' ? 'add' : 'remove')}</Col>
                                                                    <Col md={2}><b>{detail.columnName}</b></Col>
                                                                    <Col md={1}>{item.action === 'edit' ? 'from' : ''}</Col>
                                                                    <Col md={2}><b>{detail.fromValue}</b></Col>
                                                                    <Col md={1}>{item.action === 'edit' || item.action === 'added' ? 'to' : ''}</Col>
                                                                    <Col md={2}><b>{detail.toValue}</b></Col>
                                                                </Row>
                                                            )
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </Table>
                </div>
            </ModalBody>
            <ModalFooter className="mt-auto flex justify-end gap-4 px-2">
                <Button
                    onClick={() => onClose && onClose()}
                    variant="outline-danger"
                    size="sm"
                >
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default WorkflowTaskLogModal;
